import { render } from "./MobChannelViewSocial.vue?vue&type=template&id=13d4044a&scoped=true"
import script from "./MobChannelViewSocial.vue?vue&type=script&lang=js"
export * from "./MobChannelViewSocial.vue?vue&type=script&lang=js"

import "./MobChannelViewSocial.vue?vue&type=style&index=0&id=13d4044a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d4044a"]])

export default __exports__